<template>
  <div>
    <v-btn small color="blue" dark @click="dialog = true" v-show="isAdd">
      <v-icon size="14" class="mr-1">mdi-plus-circle</v-icon>
      Ekle
    </v-btn>
    <v-dialog v-model="dialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline title" v-if="isAdd">
          <v-icon left color="black">mdi-plus</v-icon>
          Opsiyon Ekle
        </v-card-title>
        <v-card-title class="headline title" v-else-if="isEdit">
          <v-icon left color="black">mdi-plus</v-icon>
          Opsiyonu Güncelle
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-col cols="12">
            <language-structured-data v-if="dialog" v-model="optionData">
              <template v-slot="{data}">
                <v-text-field
                    label="Opsiyon adını girin (*)"
                    prepend-icon="mdi-form-textbox"
                    hide-details
                    v-model="data.name"
                ></v-text-field>
              </template>
            </language-structured-data>
            <div class="mb-3"></div>
            <v-text-field
                label="Opsiyon için sistem adı tanımlayın"
                prepend-icon="mdi-text-short"
                hide-details
                v-model="addOptionSysName"
            ></v-text-field>
          </v-col>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="closeDialog()">
            <v-icon size="19" left>mdi-cancel</v-icon>
            İptal
          </v-btn>
          <v-btn color="green darken-1" text @click="addOption" v-if="isAdd">
            <v-icon dense>mdi-plus</v-icon>
            Ekle
          </v-btn>
          <v-btn color="green darken-1" text @click="updateOption" v-else-if="isEdit">
            <v-icon dense>mdi-plus</v-icon>
            Güncelle
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {mapState, mapGetters} from "vuex";
import LanguageStructuredData from "@/components/LanguageStructuredData.vue";
import {prepare, prepareFromData} from "@/core/modules/LanguageStructuredData";

export default {
  components: {LanguageStructuredData},
  name: "AddOption",
  props: {
    edit: {
      required: false
    },
    type: {
      default: "add",
      required: false
    }
  },
  data: () => ({
    dialog: false,
    optionData: null,
    addOptionSysName: "",
    resetOptionData: false,
    optionDataEdit: {}
  }),
  methods: {
    /**
     * Sisteme yeni bir opsiyon tanımlaması yapar
     */
    addOption() {
      let dispatch = this.optionStore("addOption"),
          optionData = this.optionData;
      const {addOptionSysName} = this,
          {optionType, optionName} = this.activeoptionType;

      optionData = this.convertProps(optionData, "addOption");

      this.$store
          .dispatch(dispatch, {
            optionData,
            optionType,
            optionName,
            addOptionSysName,
            typeName: optionName
          })
          .then(res => {
            if (res.status === 200) {
              this.$snotify.success("Opsiyon eklenmiştir", this.$t('PANEL.NOTIFY.SUCCESS'));
              this.$store.dispatch('Option/ModuleOptions/getOptionList', { optionType, optionName, lang: this.apiLanguage });
              this.closeDialog();
            } else {
              this.$snotify.error(res.data.errMessage, this.$t('PANEL.NOTIFY.ERROR'));
            }
          });
    },
    updateOption() {
      let dispatch = this.optionStore("updateOption"),
          optionData = this.optionData;
      const {addOptionSysName} = this,
          {optionType, optionName} = this.activeoptionType;

      optionData = this.convertProps(optionData, "updateOption");

      this.$store
          .dispatch(dispatch, {
            optionData,
            optionType,
            optionName,
            updateOptionSysName: addOptionSysName,
            updateOptionCode: this.edit[0].code
          })
          .then(res => {
            if (res.status === 200) {
              this.$snotify.success("Opsiyon başarıyla güncellendi", this.$t('PANEL.NOTIFY.SUCCESS'));
              this.closeDialog();
            } else {
              this.$snotify.error(res.data.errMessage, this.$t('PANEL.NOTIFY.ERROR'));
            }
          });
    },
    closeDialog() {
      this.resetOptionData = true;
      this.dialog = false;
    }
  },
  computed: {
    ...mapState({
      activeoptionType: state => state.Option.optionType,
      apiLanguage: state => state.Language.apiLanguage
    }),
    ...mapGetters({
      optionStore: "Option/optionStore",
      convertProps: "Language/convertProps"
    }),
    isAdd() {
      return this.type === "add";
    },
    isEdit() {
      return this.type === "edit";
    }
  },
  created() {
    if (this.isAdd) {
      this.optionData = prepare(this.apiLanguage, {
        name: ""
      })
    }
  },
  watch: {
    edit(optionData) {
      this.optionData = prepareFromData(optionData);
      this.addOptionSysName = optionData[0].sysname;
      this.dialog = true;
    }
  }
};
</script>

<style>
</style>